import SubscriptionPlansTable from '../../../components/subscriptions/subscriptionPlansTable/SubscriptionPlansTable';
import { buildSubscriptionCards, calculateYearlySavings } from '../../../utils/helpers/subscriptions/utils';
import SubscriptionCard from '../../../components/subscriptions/subscriptionCard/SubscriptionCard';
import BillingToggle from '../../../components/subscriptions/billingToggle/BillingToggle';
import { PLAN_COLORS } from '../../../utils/helpers/subscriptions/plans';
import { LanguageContext } from '../../../context/LanguageContext';
import Loader from '../../../components/spinner/Loader';
import { useDispatch, useSelector } from 'react-redux';
import styles from './SubscriptionPlans.module.css';
import { useContext, useEffect, useRef, useState } from 'react';
import Cookies from "js-cookie";
import ErrorModal from '../../../components/modal/error/ErrorModal';
import getMySubscriptionData from '../../../store/subscriptions/mySubscription/MySubscription';
import { SubscriptionPlansContext } from '../../../context/SubscriptionPlansContext';
import { scrollToTop } from '../../../utils/helpers/utils';

const SubscriptionPlans = ({ type = "list" }) => {
  const dispatch = useDispatch();
  const mySubscriptionData = useSelector((state) => state.mySubscription?.mySubscription);
  const [selected, setSelected] = useState(mySubscriptionData?.period?.period ?? 'yearly');
  const [showModal, setShowModal] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loadingPlan, setLoadingPlan] = useState(() => sessionStorage.getItem("loadingPlan"));
  const token = Cookies.get("auth_token");
  const { subscriptionPlans } = useContext(SubscriptionPlansContext);
  const setLoadingPlanRef = useRef(setLoadingPlan);

  function handleSelectPlan(plan) {
    sessionStorage.setItem("selectedPlan", plan);
  }

  useEffect(() => {
    setLoadingPlanRef.current = setLoadingPlan;
  }, [setLoadingPlan]);

  useEffect(() => {
    sessionStorage.removeItem("loadingPlan");
    sessionStorage.removeItem("selectedPlan");
    setLoadingPlan(null);
    scrollToTop();
  }, []);

  useEffect(() => {
    if (token) {
      dispatch(getMySubscriptionData(token));
    }
  }, [dispatch, token]);

  if (!subscriptionPlans || subscriptionPlans?.length === 0) return <Loader />;

  const discountPercent = calculateYearlySavings(subscriptionPlans);

  return (
    <LanguageContext.Consumer>
      {({ data, language: lang }) => {
        const t = (key) => data?.[key]?.[lang];
        const cards = buildSubscriptionCards(subscriptionPlans, selected, t, lang).map((card) => ({
          ...card,
          plan: card.plan,
          color: PLAN_COLORS[card.plan],
        }));

        return (
          <div className={styles.container} style={type !== "list" ? { background: "none" } : {}}>
            {type === "list" && (
              <div className={styles.hero} style={{ backgroundImage: "url('/assets/subscriptions/subscriptionBg.png')" }}>
                <div className={styles.overlay}></div>

                <div className={styles.heroContent}>
                  <img src='/assets/subscriptions/star.png' alt='' width='45' height='45'/>
                  <span className={styles.title}>{t("open_the_whole_world")}</span>
                  <span className={styles.subtitle}>{t("armenian_content_for_your_child")}</span>
                </div>
              </div>
            )}
            <BillingToggle {...{ selected, setSelected, t, discountPercent, loadingPlan }}/>
            <div className={`${styles.cardsGrid} ${type === "list" ? styles.center : styles.spaceBetween}`}>
              {cards.map((card) => (
                <SubscriptionCard 
                  key={card.id} 
                  subscriptionList={subscriptionPlans}
                  setSelectedPlan={handleSelectPlan}
                  {...card}
                  {...{t, lang, showModal, setShowModal, setErrorMessage, mySubscriptionData, loadingPlan, setLoadingPlan }} 
                />
              ))}
            </div>
            <SubscriptionPlansTable plansData={subscriptionPlans} t={t}/>
            {showModal === "error" && (
              <ErrorModal show={showModal === "error"} onHide={() => setShowModal("")} errorMessage={errorMessage} />
            )}
          </div>
        );
      }}
    </LanguageContext.Consumer>
  )
};

export default SubscriptionPlans;